import React from "react";
import { Col, Row } from "react-bootstrap";
import $ from "jquery";
import Slider from "react-slick";
import Cookies from "universal-cookie";

import { Link } from "@StarberryUtils";

import { getPropertyLink, getLettingsPriceQualifier } from "../../utils";
import { ShowProcessedImage } from "../common/ggfx-client/module/components/show-image";
import imageConfig from "../../../static/images/config.json";
import ComingSoonImage from "../../images/coming-soon.jpg";

import SaveProperty from "../property-search/saveProperty";
import FloorPlanModal from "../property-search/floorPlanModal";
import VideoPlay from "../Play/property-results-video";
import GetRegister from "./GetRegister/GetRegister";

var getstart = 0;
const mycookies = new Cookies();

const NoResults = ({ noPropertyData, userObjects, location }) => {
  var image1;
  var image2;
  var image3;

  return (
    <>
      {noPropertyData.length > 0 && (
        <Row className="justify-content-left">
          <Col lg={12} className="text-left mb-5">
            <div className="no-results-text">
              <p className="font-weight-bold">
                Unfortunately, we do not currently have any properties that
                match your search criteria.
              </p>
              <p>
                We have selected some of our showcase properties for you to
                browse below. Alternatively, you can search again in the search
                bar above.
              </p>
            </div>
            <div>
              {noPropertyData.map((hit, i) => {
                hit.objectID = hit._id;

                const settings = {
                  dots: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: false,
                  arrows: true,
                  mobileFirst: true,
                  responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        arrows: true,
                      },
                    },
                    {
                      breakpoint: 9999,
                      settings: "unslick",
                    },
                  ],
                };

                // property details url structure
                let uriStr = "";

                // if(hit.search_type === "sales" ) {
                //   uriStr = `commercial-property-for-sale/`
                // }

                if (
                  hit.search_type === "sales" &&
                  hit.department === "residential"
                ) {
                  uriStr = `property-for-sale/`;
                } else if (
                  hit.search_type === "lettings" &&
                  hit.department === "residential"
                ) {
                  uriStr = `property-to-rent/`;
                } else if (
                  hit.search_type === "sales" &&
                  hit.department === "commercial"
                ) {
                  uriStr = `commercial-property-for-sale/`;
                } else if (
                  hit.search_type === "lettings" &&
                  hit.department === "commercial"
                ) {
                  uriStr = `commercial-property-to-rent/`;
                } else if (
                  hit.search_type === "sales" &&
                  hit.department === "new_developments"
                ) {
                  uriStr = `new-homes-for-sale/`;
                }
                // property details url structure
                let propertyUrl = getPropertyLink(uriStr, hit);
                let priceQualifier = getLettingsPriceQualifier(hit);

                //property description
                let text_truncate = function (str, length, ending) {
                  //
                  var $win = $(window);

                  if ($win.width() <= 1500) {
                    if (length == null) {
                      length = 100;
                    }
                  } else if ($win.width() >= 1500) {
                    if (length == null) {
                      length = 220;
                    }
                  }
                  //

                  if (ending == null) {
                    ending = "...";
                  }
                  if (str.length > length) {
                    return str.substring(0, length - ending.length) + ending;
                  } else {
                    return str;
                  }
                };
                if (i == 0) {
                  getstart = 0;
                }
                if ((i + 1) % 6 === 0) {
                  if (getstart >= 4) {
                    getstart = 0;
                  }
                  getstart = getstart + 1;
                }
                
                return (
                  // <InView {...inViewOptions}>
                  //   {({ ref, inView }) => (
                  <>
                    {
                      // <motion.div
                      //   className="property-card d-md-flex flex-wrap mysingleproperty position-relative"
                      //   id={`mySaleProp${hit.objectID}`} key={i}
                      //   data-objectid={hit.objectID} data-lat={hit?._geoloc?.lat} data-lng={hit?._geoloc?.lng}
                      //   ref={ref}
                      //   initial="hidden"
                      //   animate={inView ? "visible" : "hidden"}
                      //   variants={containerItem}
                      // >
                      <div
                        className="property-card d-md-flex flex-wrap mysingleproperty position-relative"
                        id={`mySaleProp${hit.objectID}`}
                        key={i}
                        data-objectid={hit.objectID}
                        data-lat={hit?._geoloc?.lat}
                        data-lng={hit?._geoloc?.lng}
                      >
                        {(hit.status == "Sold" ||
                          hit.status == "Let" ||
                          hit.status == "Under Offer") && (
                          <div class="position-absolute text-white my-2 property-flag">
                            {hit.status == "Under Offer"
                              ? `SOLD STC`
                              : hit.status}
                          </div>
                        )}
                        <div className="view-part1">
                          <Slider className="main-slider" {...settings}>
                            <div className="main-item">
                              <Link
                                onClick={() => {
                                  mycookies.set("mySaleProp", hit.objectID, {
                                    path: "/",
                                    maxAge: 300,
                                  });
                                  sessionStorage.setItem(
                                    "searchindex",
                                    hit.objectID,
                                  );
                                }}
                                to={propertyUrl}
                                propID={hit.objectID}
                                state={{ referrer: location.pathname }}
                              >
                                {hit?.images[0]?.hd_url ? (
                                  <img src={hit?.images[0]?.hd_url} alt="" />
                                ) : (
                                  <img
                                    loading="lazy"
                                    src={ComingSoonImage}
                                    alt="Martyn Gerrard"
                                  />
                                )}
                              </Link>
                              <div className="on-map d-flex">
                                <Link
                                  onClick={() => {
                                    mycookies.set("mySaleProp", hit.objectID, {
                                      path: "/",
                                      maxAge: 300,
                                    });
                                    sessionStorage.setItem(
                                      "searchindex",
                                      hit.objectID,
                                    );
                                  }}
                                  to={`${propertyUrl}?id=propertymap`}
                                >
                                  <i className="icon-location"></i>{" "}
                                  <span className="exp-txt text-uppercase d-md-block d-none">
                                    View on Map
                                  </span>
                                </Link>
                                {/* {JSON.stringify(hit.floorplan)} */}
                                {hit.floorplan &&
                                JSON.stringify(hit.floorplan) !== "{}" ? (
                                  <FloorPlanModal
                                    floorplanimg={
                                      hit.floorplan.hd_url || hit.floorplan.url
                                    }
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="main-item d-md-none">
                              <Link
                                onClick={() => {
                                  mycookies.set("mySaleProp", hit.objectID, {
                                    path: "/",
                                    maxAge: 300,
                                  });
                                  sessionStorage.setItem(
                                    "searchindex",
                                    hit.objectID,
                                  );
                                }}
                                to={propertyUrl}
                                propID={hit.objectID}
                                state={{ referrer: location.pathname }}
                              >
                                {hit?.images[1]?.hd_url ? (
                                  <img src={hit?.images[1]?.hd_url} alt="" />
                                ) : (
                                  <img
                                    loading="lazy"
                                    src={ComingSoonImage}
                                    alt="Martyn Gerrard"
                                  />
                                )}
                              </Link>
                              {/* <Link className="play-btn" to="#"><i className="icon-play-icon"></i></Link> */}
                              {hit.virtual_tour ? (
                                hit.virtual_tour.length > 0 ? (
                                  <VideoPlay url={hit.virtual_tour} />
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="main-item d-md-none">
                              <Link
                                onClick={() => {
                                  mycookies.set("mySaleProp", hit.objectID, {
                                    path: "/",
                                    maxAge: 300,
                                  });
                                  sessionStorage.setItem(
                                    "searchindex",
                                    hit.objectID,
                                  );
                                }}
                                to={propertyUrl}
                                propID={hit.objectID}
                                state={{ referrer: location.pathname }}
                              >
                                {hit?.images[2]?.hd_url ? (
                                  <img src={hit?.images[2]?.hd_url} alt="" />
                                ) : (
                                  <img
                                    loading="lazy"
                                    src={ComingSoonImage}
                                    alt="Martyn Gerrard"
                                  />
                                )}
                              </Link>
                            </div>
                          </Slider>
                        </div>
                        <div className="view-part2 d-none d-md-block">
                          <div className="main-item">
                            <Link
                              onClick={() => {
                                mycookies.set("mySaleProp", hit.objectID, {
                                  path: "/",
                                  maxAge: 300,
                                });
                                sessionStorage.setItem(
                                  "searchindex",
                                  hit.objectID,
                                );
                              }}
                              to={propertyUrl}
                              propID={hit.objectID}
                              state={{ referrer: location.pathname }}
                            >
                              {hit?.images[2]?.hd_url ? (
                                <img src={hit?.images[2]?.hd_url} alt="" />
                              ) : (
                                <img
                                  loading="lazy"
                                  src={ComingSoonImage}
                                  alt="Martyn Gerrard"
                                />
                              )}
                            </Link>
                            {/* <Link className="play-btn" to="#"><i className="icon-play-icon"></i></Link> */}
                            {hit.virtual_tour ? (
                              hit.virtual_tour.length > 0 ? (
                                <VideoPlay url={hit.virtual_tour} />
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="main-item">
                            <Link
                              onClick={() => {
                                mycookies.set("mySaleProp", hit.objectID, {
                                  path: "/",
                                  maxAge: 300,
                                });
                                sessionStorage.setItem(
                                  "searchindex",
                                  hit.objectID,
                                );
                              }}
                              to={propertyUrl}
                              propID={hit.objectID}
                              state={{ referrer: location.pathname }}
                            >
                              {hit?.images[3]?.hd_url ? (
                                <img src={hit?.images[3]?.hd_url} alt="" />
                              ) : (
                                <img
                                  loading="lazy"
                                  src={ComingSoonImage}
                                  alt="Martyn Gerrard"
                                />
                              )}
                            </Link>
                          </div>
                        </div>
                        <Link
                          onClick={() => {
                            mycookies.set("mySaleProp", hit.objectID, {
                              path: "/",
                              maxAge: 300,
                            });
                            sessionStorage.setItem("searchindex", hit.objectID);
                          }}
                          to={propertyUrl}
                          propID={hit.objectID}
                          state={{ referrer: location.pathname }}
                          className="card-details d-flex align-items-center"
                        >
                          <div className="w-100">
                            <div className="detail-head d-flex align-items-center justify-content-between">
                              {hit.price ? (
                                <h2 className="price">
                                  &pound;{hit.price.toLocaleString()}
                                  {priceQualifier ? (
                                    <>
                                      {" "}
                                      <span className="price_qualifier">
                                        {priceQualifier}
                                      </span>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </h2>
                              ) : (
                                ""
                              )}
                              {/* <SaveProperty type="property" pid={hit.objectID} userObjects={userObjects}/> */}
                            </div>
                            <span className="address-title d-block">
                              {hit.display_address ? hit.display_address : ""}
                            </span>
                            {hit.title ? (
                              <span className="prop-title d-block">
                                {hit.title}
                              </span>
                            ) : (
                              ""
                            )}
                            {hit.description ? (
                              <p className="prop-desc d-none d-md-block mb-0">
                                {text_truncate(hit.description)}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </Link>
                        <SaveProperty
                          type="property"
                          pid={hit.objectID}
                          userObjects={userObjects}
                        />
                        {/* </motion.div> */}
                      </div>
                    }

                    {(i + 1) % 4 === 0 ? (
                      // <motion.div
                      //   className="property-card get-register d-lg-flex justify-content-between align-items-center"
                      //   ref={ref}
                      //   initial="hidden"
                      //   animate={inView ? "visible" : "hidden"}
                      //   variants={containerItem}
                      // >
                      <GetRegister getstart={getstart} />
                    ) : (
                      ""
                    )}
                  </>
                  //   )}
                  // </InView>
                );
              })}
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default NoResults;
